import http from '../utils/http';
import { interpolate } from 'utils/string';
import { NOTICES, NOTICES_LIST, NOTICE_BOARD, NOTICE_URL_ID } from '../constants/endpoints';
import type { Notice } from 'interface/notices';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetchAll(params: ServiceParams) {
  return await http.get(NOTICES_LIST, { params: { ...params } });
}

export async function fetch(params: ServiceParams) {
  return await http.get(NOTICES, { params: { ...params } });
}

export async function fetchNoticeBoard(params: ServiceParams) {
  return await http.get(NOTICE_BOARD, { params: { ...params } });
}

export async function fetchById(id: ServiceId) {
  return await http.get(interpolate(NOTICE_URL_ID, { id }));
}

export async function create(notice: Notice) {
  return await http.post(NOTICES, { body: notice });
}

export async function update(id: ServiceId, notice: Notice) {
  return await http.put(interpolate(NOTICE_URL_ID, { id }), { body: notice });
}

export async function remove(id: ServiceId) {
  return await http.delete(interpolate(NOTICE_URL_ID, { id }));
}
